<template>
  <div v-if="this.hasAnyPermission('nato-group-class-view')" class="py-4 container-fluid">
    <ToastPrime position="bottom-left" />
    <div class="row">
      <!-- Card Utama -->
      <div class="col-md-6">
        <div class="card h-100" style="height: 100%;">
          <div class="card-header py-3">
            <div class="row align-items-center">
              <div class="col-4">
                <h5 class="mb-0">NGC</h5>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <IconField>
                  <InputIcon>
                    <i class="pi pi-search"></i>
                  </InputIcon>
                  <InputText
v-model="table.search" type="text" size="small" placeholder="Search Nato"
                    class="rounded-pill" @keyup="filter" />
                </IconField>
              </div>
              <div v-if="hasAnyPermission('nato-group-class-create')" class="col-4 text-end">
                <button type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddDialog">Add</button>
              </div>
            </div>
          </div>

          <div style="flex: 1 1 auto; min-height: 0;">
            <DataTable
:value="table.onLoad ? dummyRows : table.data" class="datatable-sm text-sm" scrollable scroll-height="500px"
              table-style="min-width: 40rem" :row-class="getRowClass" :row-style="data => (selectedDetail && selectedDetail.nsc === data.nsc ? { backgroundColor: '#ECF5FF', color: '#000' } : {})"
              @row-click="selectItem">
              <Column field="nsc" header="NSC" header-class="bg-light text-dark" sortable>
                <template v-if="table.onLoad" #body>
                  <Skeleton />
                </template>
                <template v-else #body="slotProps">
                  {{ slotProps.data?.nsc || '' }}
                </template>
              </Column>
              <Column field="description" header="Description" header-class="bg-light text-dark" sortable>
                <template v-if="table.onLoad" #body>
                  <Skeleton />
                </template>
                <template v-else #body="slotProps">
                  {{ slotProps.data?.description || '' }}
                </template>
              </Column>
              <Column field="#" header="Action" header-class="bg-light" style="width: 8rem;">
                <template v-if="table.onLoad" #body>
                  <Skeleton />
                </template>
                <template v-else #body="{ data }">
                  <ButtonPrime v-if="hasAnyPermission('nato-group-class-update')"
v-tooltip.bottom="'Update'" icon="pi pi-pencil" outlined rounded size="small"
                    class="me-2" @click="openEditDialog(data)" />
                  <ButtonPrime v-if="hasAnyPermission('nato-group-class-delete')"
v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                    size="small" @click="deleteItem(data)" />
                </template>
              </Column>

              <template #empty>
                <div class="text-center py-5">
                  <img src="/no_data.png" alt="No Data" style="max-width: 330px; opacity: 0.7;" />
                  <div class="text-muted fw-semibold">No Data</div>
                </div>
              </template>
            </DataTable>
          </div>

          <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
            <BasePagination
v-model="table.page.current_pages" :page-count="table.page.total_pages || 1" size="sm"
              @click="changePage()" />
            <p>{{ (table.page.current_pages - 1) * table.page.per_pages + table.data.length }} of {{ table.total }}</p>
          </div>
        </div>
      </div>

      <!-- Card Kedua (Detail) -->
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body pt-4 pb-2 px-3 d-flex flex-column">
            <h5 class="">Definition</h5>
            <div class="mb-1 d-flex gap-3 mt-2">
              <button
class="btn btn-sm" :class="selectedLanguage === 'eng' ? 'btn-primary' : 'btn-outline-secondary'"
                @click="selectedLanguage = 'eng'">ENG</button>
              <button
class="btn btn-sm" :class="selectedLanguage === 'ind' ? 'btn-primary' : 'btn-outline-secondary'"
                @click="selectedLanguage = 'ind'">IND</button>
            </div>
            <div class="flex-grow-1">
              <template v-if="!selectedDetail">
                <span class="text-muted">Click on the NGC row to see the definition.</span>
              </template>
              <template v-else-if="!selectedLanguage">
                <span class="text-muted">Select Button ENG or IND</span>
              </template>
              <template v-else>
                <p class="text-muted mb-0" style="text-align: justify;">
                  {{ selectedLanguage === "eng"
                    ? selectedDetail.definition_eng
                    : selectedDetail.definition_ind }}
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ADD DIALOG -->
    <DialogPrime
v-model:visible="addDialog.visible" modal :header="addDialog.title" style="width: 30rem; margin: 10px;"
      class="client-modal">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <div>
            <h5 class="mb-0 fw-bold text-dark">{{ addDialog.title }}</h5>
          </div>
        </div>
      </template>
      <div class="row g-4">
        <div class="col-12">
          <div class="row g-3">
            <div class="">
              <label class="font-semibold">NSC <span class="text-danger">*</span></label>
              <InputText
v-model="addDialog.data.nsc" placeholder="NSC"
                :class="{ 'border-danger': addDialog.errorMessage.nsc }" fluid />
              <small v-if="addDialog.errorMessage.nsc" class="text-danger">{{ addDialog.errorMessage.nsc }}</small>
            </div>
            <div class="">
              <label class="font-semibold">Description <span class="text-danger">*</span></label>
              <InputText
v-model="addDialog.data.description" placeholder="Description"
                :class="{ 'border-danger': addDialog.errorMessage.description }" fluid />
              <small v-if="addDialog.errorMessage.description" class="text-danger">{{ addDialog.errorMessage.description
              }}</small>
            </div>
            <div class="">
              <label class="font-semibold">English Definition <span class="text-danger">*</span></label>
              <InputText
v-model="addDialog.data.definition_eng" placeholder="English Definition"
                :class="{ 'border-danger': addDialog.errorMessage.definition_eng }" fluid />
              <small v-if="addDialog.errorMessage.definition_eng" class="text-danger">{{
                addDialog.errorMessage.definition_eng
              }}</small>
            </div>
            <div class="">
              <label class="font-semibold">Indonesia Definition</label>
              <InputText v-model="addDialog.data.definition_ind" placeholder="Indonesia Definition" fluid />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime type="button" label="Cancel" severity="danger" raised size="small" @click="closeAddDialog" />
          <ButtonPrime
type="button" severity="contrast" raised size="small" :disabled="addDialog.onLoading"
            label="Add Nato" class="px-4" @click="saveAdd">
            <template v-if="addDialog.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>

    <!-- EDIT DIALOG -->
    <DialogPrime
v-model:visible="editDialog.visible" modal :header="editDialog.title"
      style="width: 30rem; margin: 10px;" class="client-modal">
      <template #header>
        <div class="d-flex align-items-center gap-3">
          <div>
            <h5 class="mb-0 fw-bold text-dark">{{ editDialog.title }}</h5>
          </div>
        </div>
      </template>
      <div class="">
        <label class="font-semibold">NSC <span class="text-danger">*</span></label>
        <InputText
v-model="editDialog.data.nsc" placeholder="NSC"
          :class="{ 'border-danger': editDialog.errorMessage.nsc }" fluid />
        <small v-if="editDialog.errorMessage.nsc" class="text-danger">{{ editDialog.errorMessage.nsc }}</small>
      </div>
      <div class="">
        <label class="font-semibold">Description <span class="text-danger">*</span></label>
        <InputText
v-model="editDialog.data.description" placeholder="Description"
          :class="{ 'border-danger': editDialog.errorMessage.description }" fluid />
        <small v-if="editDialog.errorMessage.description" class="text-danger">{{ editDialog.errorMessage.description
        }}</small>
      </div>
      <div class="">
        <label class="font-semibold">English Definition <span class="text-danger">*</span></label>
        <InputText
v-model="editDialog.data.definition_eng" placeholder="English Definition"
          :class="{ 'border-danger': editDialog.errorMessage.definition_eng }" fluid />
        <small v-if="editDialog.errorMessage.definition_eng" class="text-danger">{{
          editDialog.errorMessage.definition_eng
        }}</small>
      </div>
      <div class="">
        <label class="font-semibold">Indonesia Definition</label>
        <InputText v-model="editDialog.data.definition_ind" placeholder="Indonesia Definition" fluid />
      </div>
      <template #footer>
        <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
          <ButtonPrime
type="button" label="Cancel" severity="danger" raised size="small" class="px-4 border-0"
            @click="closeEditDialog" />
          <ButtonPrime
type="button" severity="contrast" raised size="small" :disabled="editDialog.onLoading"
            label="Save Nato" class="px-4" @click="saveEdit">
            <template v-if="editDialog.onLoading" #icon>
              <i class="fas fa-spinner fa-spin me-2"></i>
            </template>
          </ButtonPrime>
        </div>
      </template>
    </DialogPrime>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import DialogPrime from 'primevue/dialog';
import NoAccess from "@/components/NoAccess.vue";
import InputText from 'primevue/inputtext';
import ButtonPrime from 'primevue/button';
import natoGroupService from "@/services/dictionary/natoGroupService";
import api from "@/helpers/api";

export default {
  components: { 
    DialogPrime, 
    InputText, 
    ButtonPrime,
    NoAccess
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
  },
  data() {
    return {
      table: {
        onLoad: true,
        search: "",
        total: 0,
        data: [],
        limit: 100,
        page: { current_pages: 1, per_pages: 10, total_pages: 1 },
        loadTimeout: null,
      },
      dummyRows: Array.from({ length: 10 }, () => ({})),
      selectedDetail: null,
      selectedLanguage: null,
      addDialog: {
        visible: false,
        title: 'Add NATO',
        data: { nsc: '', description: '', definition_eng: '', definition_ind: '' },
        errorMessage: {},
        onLoading: false,
      },
      editDialog: {
        visible: false,
        title: 'Edit NATO',
        id: null,
        data: { nsc: '', description: '', definition_eng: '', definition_ind: '' },
        errorMessage: {},
        onLoading: false,
      },
    };
  },
  mounted() {
    if (this.$route.query.search) {
      this.table.search = this.$route.query.search;
    }
    if(this.hasAnyPermission('nato-group-class-view')) {
      this.getData();
    }
  },
  methods: {
    hasAnyPermission(...perms) {
      return perms.some((p) => this.authUserPermissions.includes(p));
    },
    async getData() {
      this.table.onLoad = true;
      try {
        const response = await api(this, natoGroupService.list({
          search: this.table.search,
          limit: this.table.limit,
          page: this.table.page.current_pages,
        }), false);
        const paged = response.data || {};
        this.table.data = paged.data || [];
        this.table.total = paged.total || this.table.data.length;
        this.table.page.total_pages = paged.last_page || 1;
        this.table.page.current_pages = paged.current_page || 1;
        this.table.page.per_pages = paged.per_page || this.table.limit;
      } catch {
        this.table.data = [];
        this.table.total = 0;
        this.table.page.total_pages = 1;
      } finally {
        this.table.onLoad = false;
      }
    },

    selectItem(event) {
      const item = event.data;
      this.selectedDetail = {
        nsc: item.nsc,
        definition_eng: item.definition_eng,
        definition_ind: item.definition_ind,
      };
      this.selectedLanguage = 'eng';
    },
    getRowClass(data) {
      const isSelected = this.selectedDetail && this.selectedDetail.nsc === data.nsc;
      return [
        'cursor-pointer',
        isSelected ? '' : '',
      ].join(' ');
    },

    filter() {
      clearTimeout(this.table.loadTimeout);
      this.table.loadTimeout = setTimeout(() => {
        this.$router.push({ query: this.table.search ? { search: this.table.search } : null });
        this.table.page.current_pages = 1;
        this.getData();
      }, 500);
    },

    changePage() {
      this.getData();
    },

    async deleteItem(item) {
      this.confirmDialog("You won't be able to revert this!", "delete it").then(async (result) => {
        if (result.isConfirmed) {
          await api(this, natoGroupService.delete(item.id));
          this.getData();
        }
      });
    },

    openAddDialog() {
      this.addDialog.visible = true;
      this.addDialog.data = { nsc: '', description: '', definition_eng: '', definition_ind: '' };
      this.addDialog.errorMessage = {};
      this.addDialog.onLoading = false;
    },

    closeAddDialog() {
      this.addDialog.visible = false;
    },

    async saveAdd() {
      this.addDialog.errorMessage = {};
      if (!this.addDialog.data.nsc) this.addDialog.errorMessage.nsc = 'NSC wajib diisi';
      if (!this.addDialog.data.description) this.addDialog.errorMessage.description = 'Description wajib diisi';
      if (!this.addDialog.data.definition_eng) this.addDialog.errorMessage.definition_eng = 'English Definition wajib diisi';
      if (Object.keys(this.addDialog.errorMessage).length > 0) return;

      this.addDialog.onLoading = true;
      try {
        await api(this, natoGroupService.create(this.addDialog.data), true);
        this.addDialog.visible = false;
        this.getData();
      } catch (error) {
        if (error.response?.data?.code == 400 && Array.isArray(error.response.data.data)) {
          error.response.data.data.forEach((v) => {
            this.addDialog.errorMessage[v.path] = v.msg;
          });
        }
      } finally {
        this.addDialog.onLoading = false;
      }
    },

    openEditDialog(rowData) {
      this.editDialog.visible = true;
      this.editDialog.id = rowData.id;
      this.editDialog.data = {
        nsc: rowData.nsc || '',
        description: rowData.description || '',
        definition_eng: rowData.definition_eng || '',
        definition_ind: rowData.definition_ind || ''
      };
      this.editDialog.errorMessage = {};
      this.editDialog.onLoading = false;
    },

    closeEditDialog() {
      this.editDialog.visible = false;
    },

    async saveEdit() {
      this.editDialog.errorMessage = {};
      if (!this.editDialog.data.nsc) this.editDialog.errorMessage.nsc = 'NSC wajib diisi';
      if (!this.editDialog.data.description) this.editDialog.errorMessage.description = 'Description wajib diisi';
      if (!this.editDialog.data.definition_eng) this.editDialog.errorMessage.definition_eng = 'English Definition wajib diisi';
      if (Object.keys(this.editDialog.errorMessage).length > 0) return;

      this.editDialog.onLoading = true;
      try {
        await api(this, natoGroupService.patch(this.editDialog.id, this.editDialog.data), true);
        this.editDialog.visible = false;
        this.getData();
      } catch (error) {
        if (error.response?.data?.code == 400 && Array.isArray(error.response.data.data)) {
          error.response.data.data.forEach((v) => {
            this.editDialog.errorMessage[v.path] = v.msg;
          });
        }
      } finally {
        this.editDialog.onLoading = false;
      }
    },
  },
};
</script>
